(() => {
	function initSlideshow(slideshow) {
		if (slideshow.dataset.initialized) return;
		slideshow.dataset.initialized = "true";

		const track = slideshow.querySelector(".custom-feature-showcase__slides");
		const slides = Array.from(
			slideshow.querySelectorAll(".custom-feature-showcase__slide"),
		);
		const dots = Array.from(
			slideshow.querySelectorAll(".swiper-pagination-bullet"),
		);
		const prevButton = slideshow.querySelector(
			".custom-feature-showcase__arrow--prev",
		);
		const nextButton = slideshow.querySelector(
			".custom-feature-showcase__arrow--next",
		);

		if (slides.length < 2) return;

		let currentIndex = Math.max(
			0,
			slides.findIndex(slide => slide.classList.contains("is-active")),
		);
		let autoplayTimer = null;

		const autoplay = slideshow.dataset.autoplay === "true";
		const speed = (parseFloat(slideshow.dataset.speed) || 5) * 1000;

		function goToSlide(index) {
			const nextIndex = (index + slides.length) % slides.length;

			slides[currentIndex].classList.remove("is-active");
			slides[currentIndex]
				.querySelectorAll('.custom-feature-showcase__marker[aria-expanded="true"]')
				.forEach(marker => marker.setAttribute("aria-expanded", "false"));
			dots[currentIndex] && dots[currentIndex].classList.remove("swiper-pagination-bullet-active");

			currentIndex = nextIndex;
			track.style.transform = `translateX(-${currentIndex * 100}%)`;

			slides[currentIndex].classList.add("is-active");
			dots[currentIndex] && dots[currentIndex].classList.add("swiper-pagination-bullet-active");
		}

		function startAutoplay() {
			if (!autoplay) return;
			stopAutoplay();
			autoplayTimer = setInterval(() => goToSlide(currentIndex + 1), speed);
		}

		function stopAutoplay() {
			if (autoplayTimer) {
				clearInterval(autoplayTimer);
				autoplayTimer = null;
			}
		}

		function goToSlideAndResetAutoplay(index) {
			goToSlide(index);
			startAutoplay();
		}

		if (prevButton) {
			prevButton.addEventListener("click", () =>
				goToSlideAndResetAutoplay(currentIndex - 1),
			);
		}

		if (nextButton) {
			nextButton.addEventListener("click", () =>
				goToSlideAndResetAutoplay(currentIndex + 1),
			);
		}

		dots.forEach((dot, index) => {
			dot.addEventListener("click", () =>
				goToSlideAndResetAutoplay(index),
			);
		});

		slideshow.addEventListener("mouseenter", stopAutoplay);
		slideshow.addEventListener("mouseleave", startAutoplay);
		slideshow.addEventListener("focusin", stopAutoplay);
		slideshow.addEventListener("focusout", startAutoplay);

		startAutoplay();
	}

	function initMarkers(slideshow) {
		if (slideshow.dataset.markersInitialized) return;
		slideshow.dataset.markersInitialized = "true";

		const markers = Array.from(
			slideshow.querySelectorAll(".custom-feature-showcase__marker"),
		);
		if (markers.length === 0) return;

		const supportsHover = window.matchMedia("(hover: hover)").matches;
		let hideTimeout;

		function closeMarker(marker) {
			marker.setAttribute("aria-expanded", "false");
		}

		function openMarker(marker) {
			clearTimeout(hideTimeout);
			markers.forEach(other => {
				if (other !== marker) closeMarker(other);
			});
			marker.setAttribute("aria-expanded", "true");
		}

		function closeMarkerWithDelay(marker) {
			clearTimeout(hideTimeout);
			hideTimeout = setTimeout(() => closeMarker(marker), 150);
		}

		function toggleMarker(marker) {
			const isOpen = marker.getAttribute("aria-expanded") === "true";
			if (isOpen) closeMarker(marker);
			else openMarker(marker);
		}

		markers.forEach(marker => {
			marker.addEventListener("mouseenter", () => openMarker(marker));
			marker.addEventListener("mouseleave", () => closeMarkerWithDelay(marker));
			marker.addEventListener("focusin", () => openMarker(marker));
			marker.addEventListener("focusout", () => closeMarker(marker));
			marker.addEventListener("click", event => {
				if (!supportsHover) {
					event.preventDefault();
					toggleMarker(marker);
				}
			});
			marker.addEventListener("keydown", event => {
				if (event.key === "Escape") closeMarker(marker);
			});
		});

		document.addEventListener("click", event => {
			if (!slideshow.contains(event.target)) {
				markers.forEach(closeMarker);
			}
		});

		// Matches sections/product-markers.liquid's own behavior: the first marker on
		// the active slide starts open rather than every marker starting closed.
		const activeSlide = slideshow.querySelector(".custom-feature-showcase__slide.is-active");
		const firstMarker = activeSlide && activeSlide.querySelector(".custom-feature-showcase__marker");
		if (firstMarker) openMarker(firstMarker);
	}

	function initAllSlideshows(root = document) {
		root
			.querySelectorAll(".custom-feature-showcase__slideshow")
			.forEach(slideshow => {
				initSlideshow(slideshow);
				initMarkers(slideshow);
			});
	}

	document.addEventListener("DOMContentLoaded", () => initAllSlideshows());
	document.addEventListener("shopify:section:load", event =>
		initAllSlideshows(event.target),
	);
	if (document.readyState !== "loading") initAllSlideshows();
})();